import React from "react";
import "flag-icons/css/flag-icons.min.css";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./ui/select";
import { LANGS } from "../i18n";
import { useLang } from "../i18n/LanguageProvider";

import { tr } from "../i18n";
export default function LanguageSwitcher({ className = "", testid = "language-switcher" }) {
  const { lang, setLang } = useLang();
  const cur = LANGS.find((l) => l.code === lang);
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid={testid} aria-label={tr("Language")}
        className={`w-auto gap-2 h-9 rounded-full border-white/20 bg-transparent text-white text-[13px] px-3 hover:border-[#c2a15a] transition-colors ${className}`}>
        <span className="flex items-center gap-2">
          <span className={`fi fi-${cur.flag} rounded-[2px]`} />
          <span className="uppercase tracking-wide">{cur.code}</span>
        </span>
      </SelectTrigger>
      <SelectContent className="z-[200]">
        {LANGS.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`${testid}-${l.code}`}>
            <span className="flex items-center gap-2.5"><span className={`fi fi-${l.flag} rounded-[2px]`} />{l.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
